import React, { useEffect } from "react";
import Layout from "./containers/UI/Layout/Layout";
import Services from "./containers/UI/Services/Services";
import { Route, Switch, Redirect } from "react-router-dom";
import Offers from "./containers/UI/Offers/Offers";
import Dates from "./containers/UI/Dates/Dates";
import Auth from "./containers/Administration/Auth/Auth";
import Admin from "./containers/Administration/hoc/Admin";
import Adminlook from "./containers/Administration/Adminlook/Adminlook";
import { connect } from "react-redux";
import Adminoffers from "./containers/Administration/Adminoffers/Adminoffers";
import Adminmasters from "./containers/Administration/Adminmasters/Adminmasters";
import Logout from "./containers/Administration/Logout/Logout";
import { autoLogin } from "./store/actions/actions";

function App(props) {
  useEffect(() => {
    props.autoLogin();
  }, [props]);

  const services = (
    <Layout>
      <Services>
        <Offers />
      </Services>
    </Layout>
  );

  const dates = (
    <Layout>
      <Services>
        <Dates />
      </Services>
    </Layout>
  );

  const auth = (
    <Layout>
      <Services>
        <Auth />
      </Services>
    </Layout>
  );

  const adminLook = (
    <Admin>
      <Adminlook />
    </Admin>
  );

  const adminOffers = (
    <Admin>
      <Adminoffers />
    </Admin>
  );

  const adminMaster = (
    <Admin>
      <Adminmasters />
    </Admin>
  );

  const adminLogout = (
    <Admin>
      <Logout />
    </Admin>
  );

  if (props.isAuthenticated) {
    return (
      <>
        <Route path="/admin/look" render={() => adminLook} />
        <Route path="/admin/offer" render={() => adminOffers} />
        <Route path="/admin/master" render={() => adminMaster} />
        <Route path="/admin/logout" render={() => adminLogout} />
        <Redirect to="/admin/look" />
      </>
    );
  }

  return (
    <Switch>
      <Route path="/" exact render={() => services} />
      {props.totalMoney ? <Route path="/dates" render={() => dates} /> : null}
      <Route path="/auth" render={() => auth} />
      <Redirect to="/" />
    </Switch>
  );
}

function mapStateToProps(state) {
  return {
    totalMoney: state.totalMoney,
    isAuthenticated: !!state.token,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    autoLogin: () => dispatch(autoLogin()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
